import React, { useState, useEffect, useCallback } from 'react';
import { Badge, Dropdown, Button, Empty, List } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { adminAPI } from '../api/admin';

/**
 * زنگوله اعلان‌های مدیر — مثلاً وقتی شماره تماس یک دعوت‌نامه‌ی تایید‌شده تغییر
 * می‌کند. فقط برای مدیر (نه استاد) نمایش داده می‌شود.
 */
export default function AdminNotificationsBell() {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [open, setOpen] = useState(false);

  const load = useCallback(async () => {
    try {
      const res = await adminAPI.getAdminNotifications();
      if (res.data.success) {
        setNotifications(res.data.notifications || []);
        setUnreadCount(res.data.unreadCount || 0);
      }
    } catch {
      // silent — این فقط یک ویجت کمکی است
    }
  }, []);

  useEffect(() => {
    load();
    const interval = setInterval(load, 60 * 1000); // هر دقیقه
    return () => clearInterval(interval);
  }, [load]);

  const markRead = async (id) => {
    try {
      await adminAPI.markNotificationRead(id);
      load();
    } catch { /* noop */ }
  };

  const menu = (
    <div style={{ width: 340, maxHeight: 400, overflowY: 'auto', background: '#fff', borderRadius: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.15)' }}>
      {notifications.length === 0 ? (
        <Empty description="اعلانی وجود ندارد" style={{ padding: 24 }} />
      ) : (
        <List
          dataSource={notifications}
          renderItem={(n) => (
            <List.Item
              onClick={() => !n.isRead && markRead(n._id)}
              style={{ padding: '10px 16px', cursor: 'pointer', background: n.isRead ? '#fff' : '#fff7e6' }}
            >
              <div style={{ width: '100%' }}>
                <div style={{ fontWeight: n.isRead ? 400 : 600, fontSize: 13 }}>{n.message}</div>
                <div style={{ color: '#999', fontSize: 11 }}>{new Date(n.createdAt).toLocaleString('fa-IR')}</div>
              </div>
            </List.Item>
          )}
        />
      )}
    </div>
  );

  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      dropdownRender={() => menu}
      trigger={['click']}
      placement="bottomRight"
    >
      <Badge count={unreadCount} size="small">
        <Button shape="circle" icon={<BellOutlined />} />
      </Badge>
    </Dropdown>
  );
}
